import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocShowDialogState = atom({
  key: "ocShowDialogState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
